module.exports = __webpack_public_path__ + "static/img/icon_favorite_38.9c755ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_favorite_38.svg
// module id = i9iX
// module chunks = 10